/** @jsx jsx */
import { jsx, Box, useColorMode } from 'theme-ui'
import { motion } from 'framer-motion'
import { useMapboxContext } from '../useMapboxContext'

const Container = React.forwardRef(({ children }, ref) => {
  const [colorMode] = useColorMode()
  const { loaded } = useMapboxContext()

  return (
    <>
      {/*
        Nested <div> here to make Mapbox widget fit into page layout and also
        expand to fit available space, see https://stackoverflow.com/a/59745053/4970
      */}
      <motion.div
        sx={{
          position: 'relative',
          flexGrow: 1,
          overflow: 'hidden',
        }}
        animate={{
          opacity: loaded ? 1 : 0,
        }}
      >
        <Box
          ref={ref}
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'url(/noise.gif)',
            backgroundPosition: 'center center',
            mixBlendMode: 'multiply',
            opacity: colorMode === 'dark' ? 0.4 : 0,
            zIndex: 500,
            pointerEvents: 'none',
          }}
        />
        {children}
      </motion.div>
    </>
  )
})

export { Container }
